module.exports = __webpack_public_path__ + "img/blog-7-1.97301de8.webp";